var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 16.0003H2.66667C2.48986 16.0003 2.32029 15.9301 2.19526 15.8051C2.07024 15.68 2 15.5105 2 15.3337C2 15.1568 2.07024 14.9873 2.19526 14.8623C2.32029 14.7372 2.48986 14.667 2.66667 14.667H21.3333C21.5101 14.667 21.6797 14.7372 21.8047 14.8623C21.9298 14.9873 22 15.1568 22 15.3337C22 15.5105 21.9298 15.68 21.8047 15.8051C21.6797 15.9301 21.5101 16.0003 21.3333 16.0003Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 9.33333H2.66667C2.48986 9.33333 2.32029 9.2631 2.19526 9.13807C2.07024 9.01305 2 8.84348 2 8.66667C2 8.48986 2.07024 8.32029 2.19526 8.19526C2.32029 8.07024 2.48986 8 2.66667 8H21.3333C21.5101 8 21.6797 8.07024 21.8047 8.19526C21.9298 8.32029 22 8.48986 22 8.66667C22 8.84348 21.9298 9.01305 21.8047 9.13807C21.6797 9.2631 21.5101 9.33333 21.3333 9.33333Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.ac6f7ee7.svg";
export { ForwardRef as ReactComponent };